import { useEffect, useState } from "react";
import { useCookies } from "react-cookie";

const useFetchWithAuthorization = (url) => {
  const [cookies] = useCookies(["token"]);
  const token = cookies.token;

  const [data, setData] = useState(null);
  const [error, setError] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await fetch(url, {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        });

        if (response.status === 401) {
            throw new Error("Unauthorized");
        }
        if (!response.ok) {
          throw new Error("Request failed");
        }

        const responseData = await response.json();
        setData(responseData);
        setLoading(false);
      } catch (error) {
        setError(error.message);
        setLoading(false);
      }
    };

    fetchData();
  }, [url, token]);

  return { data, loading, error };
};

export default useFetchWithAuthorization;
